var map = {
	"./ADA.svg": 979,
	"./BCH.svg": 980,
	"./BNB.svg": 981,
	"./BTC.svg": 982,
	"./CHZ.svg": 983,
	"./DASH.svg": 984,
	"./DOGE.svg": 985,
	"./DOT.svg": 986,
	"./ETC.svg": 987,
	"./ETH.svg": 988,
	"./EUR.svg": 989,
	"./GBP.svg": 990,
	"./LINK.svg": 991,
	"./LTC.svg": 992,
	"./MATIC.svg": 993,
	"./MKR.svg": 994,
	"./SHIB.svg": 995,
	"./SOL.svg": 996,
	"./TRX.svg": 997,
	"./UNI.svg": 998,
	"./USD.svg": 999,
	"./USDT.svg": 1000,
	"./XLM.svg": 1001,
	"./XMR.svg": 1002,
	"./XRP.svg": 1003,
	"./documents.svg": 1004
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 978;